import { render, staticRenderFns } from "./AmwayPayAccount.vue?vue&type=template&id=0faa174f&scoped=true&"
import script from "./AmwayPayAccount.vue?vue&type=script&lang=js&"
export * from "./AmwayPayAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faa174f",
  null
  
)

export default component.exports